import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getProfileInfo } from "../../axios/axiosFunctions";
import { Typography } from "@mui/material";
import DisplayProfileForm from "../../components/DisplayProfileForm";
import MyAssessmentsProfile from "../../components/MyAssessmentsProfile";

const ProfileAdmin = () => {
  const { userId } = useParams();
  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    const callProfileInfo = async () => {
      const resp = await getProfileInfo(userId);
      if (resp) {
        setUserInfo(resp.user);
      }
    };
    callProfileInfo();
  }, []);

  return (
    <>
      <Typography variant="h3" fontWeight={500} color="secondary">
        Profile
      </Typography>
      <DisplayProfileForm
        userInfo={userInfo}
        userId={userId}
        setUserInfo={setUserInfo}
      />
      <MyAssessmentsProfile userId={userId} />
    </>
  );
};

export default ProfileAdmin;
